<div class="container-fluid ptCustom">

    <div class="my-2">
        <a [routerLink]="['/admin-portal/chamber/pending-applications']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all applications</a>
    </div>

    <div class="row">

        <div class="col-lg-8 col-md-8 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Company Information</h4>
                            <a href="javascript:void(0);" (click)="editCompanyInfo(app)" *ngIf="!app.isClosed"><i class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Company/Organization Name</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.companyName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span># Employees in 10 county region</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.employeeCount.text}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Phone</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.businessPhone | mask: '(000) 000-0000'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Address</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.businessAddress}}, {{app.businessCity}}, {{app.businessState}} {{app.businessZip}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Self-Identifies as...</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{selfIdentitiesText}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Minority-owned certifications</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{minorityCertsText}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="app.brokerName != null">
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Broker Name</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.brokerName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Broker Email</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.brokerEmail}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Member Liaison Information</h4>
                            <a href="javascript:void(0);" (click)="editLiaisonInfo(app)" *ngIf="!app.isClosed"><i class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Liaison Name</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.liaisonFirstName}} {{app.liaisonLastName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Liaison Email</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.liaisonEmail}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Liaison Phone</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.liaisonPhone | mask: '(000) 000-0000'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Job Title</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.liaisonTitle}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Referred By</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.salesperson}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Membership</h4>
                            <a href="javascript:void(0);" (click)="editMembershipInfo(app)" *ngIf="!app.isClosed"><i class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Membership Level</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.membershipLevel.text}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Total</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{priceString}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Payment Type</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.paymentTypeText}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Auto-renew</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{app.isAutoRenew ? "Yes" : "No"}}</span>
                                        </div>
                                    </div>
                                </div>-->

                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-4 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader justify-content-center">
                            <h4>Review Application</h4>
                        </div>
                        <div class="detailsSection">
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Application Submitted</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{app.submittedDate}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Member</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{app.companyName}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Membership Level</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{app.membershipLevel.text}}</span>
                                </div>
                            </div>
                            <div *ngIf="!app.isClosed">
                                <div class="mb-3">
                                    <input [(ngModel)]="notes" type="text" class="form-control" id="verifierNotes" placeholder="Notes">
                                </div>
                                <div class="mb-3">
                                    <input [(ngModel)]="salesForceId" type="text" class="form-control" id="sfId" placeholder="Salesforce Id">
                                    <div *ngIf="sfIdError">
                                        <i class="fas fa-exclamation-circle"></i> This field is required.
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input [(ngModel)]="salesForceSalesOppId" type="text" class="form-control" id="sfId" placeholder="Sales opportunity Id">
                                    <div *ngIf="sfSalesOppIdError">
                                        <i class="fas fa-exclamation-circle"></i> This field is required.
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <a href="javascript:void(0);" (click)="approveApplication()" type="button" class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i> verify member</a>
                                </div>
                                <div class="text-center">
                                    <a href="javascript:void(0);" (click)="rejectApplication()" class="text-white"><small>Reject Member</small></a>
                                </div>
                            </div>
                            <div *ngIf="app.isClosed" class="mt-4">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Status</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span><strong>{{app.status}}</strong></span>
                                    </div>
                                </div>
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Reviewer Notes</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span>{{app.notes}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</div>